import { render, staticRenderFns } from "./account_settings.vue?vue&type=template&id=45acd22f&scoped=true&"
import script from "./account_settings.vue?vue&type=script&lang=js&"
export * from "./account_settings.vue?vue&type=script&lang=js&"
import style0 from "./account_settings.vue?vue&type=style&index=0&id=45acd22f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45acd22f",
  null
  
)

export default component.exports